import { createComponent } from "@helpers/admin";
import ImageComponent from "@template/components/Image";

export const Image = createComponent({
  label: "Image",
  component: ({ src, alt, roundCorners, objectFit, width }) => (
    <ImageComponent
      src={src}
      alt={alt}
      style={{
        borderRadius: roundCorners ? 24 : 0,
        objectFit: objectFit,
        width: width,
        height: "100%",
        overflow: "clip",
      }}
    />
  ),
  fields: {
    src: {
      label: "Source",
      type: "text",
    },
    alt: {
      label: "Alt",
      type: "text",
    },
    objectFit: {
      label: "Image Fit",
      type: "select",
      options: [
        {
          label: "Fill",
          value: "fill",
        },
        {
          label: "Contain",
          value: "contain",
        },
        {
          label: "Cover",
          value: "cover",
        },
        {
          label: "None",
          value: "none",
        },
        {
          label: "Scale Down",
          value: "scale-down",
        },
      ],
    },
    width: {
      label: "Width",
      type: "select",
      options: [
        {
          label: "100%",
          value: "100%",
        },
        {
          label: "Auto",
          value: "auto",
        },
        {
          label: "Fit Content",
          value: "fit-content",
        },
      ],
    },
    roundCorners: {
      label: "Round Corners",
      type: "boolean",
    },
  },
});
